/*eslint-disable*/ export const messages = JSON.parse("{\"button.aria.loading\":[\"Indlæser...\"]}");
//# sourceMappingURL=messages.mjs.map